import React from 'react'

const Loading = ({...props}) => {
    return (
        <div className="loading-component is-active mt-3">
            <div className="loader is-loading"></div>
        </div>
    )
}

export default Loading
